package com.daytimegaming.ourdailyfinances.data.network.service

import com.daytimegaming.ourdailyfinances.data.network.ApiClient
import com.daytimegaming.ourdailyfinances.data.network.dto.CreateRealEstateHoldingRequest
import com.daytimegaming.ourdailyfinances.data.network.dto.RealEstateHoldingDto
import com.daytimegaming.ourdailyfinances.data.network.dto.RealEstateHoldingListResponse
import com.daytimegaming.ourdailyfinances.data.network.dto.UpdateRealEstateHoldingRequest
import com.daytimegaming.ourdailyfinances.data.network.dto.MessageResponse
import io.ktor.client.call.body
import io.ktor.client.request.delete
import io.ktor.client.request.get
import io.ktor.client.request.patch
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType

class RealEstateService(private val apiClient: ApiClient) {
    suspend fun createRealEstateHolding(request: CreateRealEstateHoldingRequest): RealEstateHoldingDto =
        apiClient.http.post("${apiClient.baseUrl}/real-estate-holdings") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()

    suspend fun getRealEstateHoldings(): RealEstateHoldingListResponse =
        apiClient.http.get("${apiClient.baseUrl}/real-estate-holdings").body()

    suspend fun getRealEstateHolding(realEstateHoldingId: String): RealEstateHoldingDto =
        apiClient.http.get("${apiClient.baseUrl}/real-estate-holdings/$realEstateHoldingId").body()

    suspend fun updateRealEstateHolding(
        realEstateHoldingId: String,
        request: UpdateRealEstateHoldingRequest
    ): RealEstateHoldingDto =
        apiClient.http.patch("${apiClient.baseUrl}/real-estate-holdings/$realEstateHoldingId") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()

    suspend fun deleteRealEstateHolding(realEstateHoldingId: String): MessageResponse =
        apiClient.http.delete("${apiClient.baseUrl}/real-estate-holdings/$realEstateHoldingId").body()

    suspend fun refreshValueEstimate(realEstateHoldingId: String): RealEstateHoldingDto =
        apiClient.http.post("${apiClient.baseUrl}/real-estate-holdings/$realEstateHoldingId/refresh-value-estimate").body()
}
